import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination'; // if you want pagination dots
import 'swiper/css/navigation'; // if you want arrows
import { Pagination } from 'swiper/modules';
import { useTranslation } from "react-i18next";

const Services = (props) => {
  const { t } = useTranslation("clientSite"); // expects keys under "header.*"
  return (
    <>
      <div className="row gy-4">
        <div className="row justify-content-center section-title text-center">
          <div className="col-lg-7">
            <h3 className="font-alt">{props.site.servicePageTitle}</h3>
            <p className="body">{props.site.serviceDescription}</p>
          </div>
        </div>
        {/* {ServiceContent.map((val, i) => (
          <div
            className="col-sm-6 col-lg-4"
            key={i}
          >
            <div className="feature-box-02">
              <h6>
                {val.service}
              </h6>
              <p>{val.desc}</p>
            </div>
          </div>
        ))} */}

<Swiper
  spaceBetween={20}
  slidesPerView={1}
  pagination={{ clickable: true }}
  modules={[Pagination]}
  breakpoints={{
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  }}
>
  {props.site.services.map((val, i) => (
    <SwiperSlide key={i}>
      <div className="service-box">
            <div className="feature-box-02">
              <h6 style={{textAlign:"center"}}>
                {val.name}
              </h6>
              <p className="body" style={{textAlign:"center"}}>{val.description}</p>
            </div>
            </div>
    </SwiperSlide>
  ))}
</Swiper>
        
      </div>
      <div style={{textAlign:"center"}}>
        <a target="_blank" style={{marginTop:"3rem"}} className="px-btn px-btn-theme btn-md" href={"make-a-booking?id=" + props.site.barberShopId}>
            {t("bookNow")}
        </a>
      </div>
    </>
  );
};

export default Services;
